<template>
    <rents-extension-update
        :uuid="rent.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                sid,
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Rent Updated!</template>

                <p>The rent has been successfully updated. We have notified your tenant(s) of the extension.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="btn text-center"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-blue
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update(form)"
                >
                    <div class="border-b px-4 pt-6 sm:px-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Extend Due Date
                        </h6>

                        <div class="text-grey-darker mb-6">
                            <p>
                                You can offer an extension on this rent by changing it's due date.
                            </p>
                        </div>

                        <validator-alert :sid="sid" />

                        <grid-layout>
                            <grid-layout-item>
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="due_at"
                                >
                                    <template slot="label">Due</template>

                                    <input-date
                                        v-model="form.due_at"
                                        :sid="sid"
                                        name="due_at"
                                    />
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-blue w-full md:w-auto"
                        >
                            Update Rent
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-blue>
        </div>
    </rents-extension-update>
</template>

<script>
    import _ from 'lodash'
    import moment from 'moment'
    import RentsExtensionUpdate from '../../../../../../components/rents-extension-update'

    export default {
        components: {
            RentsExtensionUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            rent: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false,
                form: {
                    due_at: _.chain(this.rent.due_at)
                        .thru(value => {
                            if (!value) {
                                return value
                            }

                            return moment(value).format('DD/MM/YYYY')
                        })
                        .value()
                }
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
